import { atomWithStorage } from 'jotai/utils';

export const currentTenantAtom = atomWithStorage<
  | {
      id: string;
      name: string;
    }
  | undefined
>('currentTenant', undefined);
